import { CLASS_ANCHORED } from 'components/UI/SpeedDial/BaseSpeedDial';
import { EPIC_APP_ID } from 'pages/ApplicationRequest/components/containers/1616BridgesEpic/_const';

export const NUM_ASSIGNMENTS = 7;
export const LINK_FAQ =
	'https://infonet.upmc.com/infonet/ls/content/4164666884215481/upmc-bridges-epic-security-and-training-validation-exercise-tip-sheet-pdf-1764800971';
export const CLASS_SPEED_DIAL = { fab: CLASS_ANCHORED };
/**
 * @type {{ ID: number, Name: string }}
 */
export const OBJ_APP_BRIDGES = { ID: EPIC_APP_ID, Name: 'Bridges' };
/**
 * @type {{ ID: number, Name: string }}
 */
export const OBJ_APP_HP = { ID: 1696, Name: 'Health Plan' };
export const OBJ_PARAMS = { ID: 'ID' };
export const OBJ_SUPPLEMENTS = {
	NPI: 'SUPPLEMENT_NPI',
	RESEARCH: 'SUPPLEMENT_RESEARCH',
};
export const STEP_DASHBOARD = 'Dashboard';
export const STEP_EDIT = 'Edit';
export const ARR_STEPS = [STEP_DASHBOARD, STEP_EDIT, 'Review', 'Submit'];

//#region Data entities
/**
 * @class
 * @constructor
 */
export class TrainingTrack {
	constructor(objTrainingTrack) {
		/**
		 * @type {number}
		 */
		this.id = objTrainingTrack.TrainingTrackID ?? -1;
		/**
		 * @type {string}
		 */
		this.name = objTrainingTrack.Name ?? '';
		/**
		 * @type {boolean}
		 */
		this.active =
			objTrainingTrack.Active !== null ? objTrainingTrack.Active : true;
	}
}

/**
 * @class
 * @constructor
 */
class JobCategoryAssignment {
	constructor(objJobCategoryAssignment) {
		/**
		 * @type {string} unique identifier of job category assignment, accounting for copies
		 */
		this.id =
			objJobCategoryAssignment.ID !== undefined
				? objJobCategoryAssignment.ID.toString()
				: '';
		/**
		 * @type {JobCategory}
		 */
		this.jobCategory = new JobCategory(
			objJobCategoryAssignment.JobCategory ?? {},
		);
		/**
		 * @type {boolean}
		 */
		this.validated = objJobCategoryAssignment.Validated ?? false;
		/**
		 * @type {boolean}
		 */
		this.experienced = objJobCategoryAssignment.Experienced ?? false;
		/**
		 * @type {null|-1|1|2|3}
		 */
		this.wave = objJobCategoryAssignment.Wave ?? null;
		/**
		 * @type {boolean}
		 */
		this.trained = objJobCategoryAssignment.Trained ?? false;
	}
}

/**
 * @class
 * @constructor
 */
export class JobCategory {
	constructor(objJobCategory) {
		/**
		 * @type {number}
		 */
		this.id = objJobCategory.ID ?? -1;
		/**
		 * @type {number}
		 */
		this.appID = objJobCategory.AppID ?? -1;
		/**
		 * @type {string}
		 */
		this.name = objJobCategory.Name ?? '';
		/**
		 * @type {'Primary Category' | 'Enhancement Category' | 'Link Category' }
		 */
		this.type = objJobCategory.Type ?? '';
		/**
		 * @type {boolean}
		 */
		this.active =
			objJobCategory.Active !== null &&
			objJobCategory.Active !== undefined
				? objJobCategory.Active
				: objJobCategory.active !== null &&
				  objJobCategory.active !== undefined
					? objJobCategory.active
					: true;
	}

	/**
	 * Determines whether the job category is "primary".
	 *
	 * @returns {boolean} indication of primary job category;
	 */
	isPrimary() {
		return this.type === 'Primary Category';
	}
}

export class Supplement {
	constructor(objSupplement) {
		/**
		 * @type {number} unique identifier of assignment associated with supplement
		 */
		this.id = objSupplement.ID ?? -1;
		/**
		 * @type {OBJ_SUPPLEMENTS.NPI | OBJ_SUPPLEMENTS.RESEARCH | null} type of supplement
		 */
		this.type = objSupplement.Type ?? null;
		/**
		 * @type {any} supplement value(s)
		 */
		this.value = objSupplement.Value ?? null;
	}
}

/**
 * @class
 * @constructor
 */
export class JobCategoryDetails extends JobCategory {
	constructor(objJobCategoryDetails) {
		super(objJobCategoryDetails);

		/**
		 * @type {string}
		 */
		this.description = objJobCategoryDetails.Description ?? '';
		/**
		 * @type {string}
		 */
		this.templateName = objJobCategoryDetails.TemplateName ?? '';
		/**
		 * @type {string}
		 */
		this.dayInLifeActivityPre =
			objJobCategoryDetails.DayInLifeActivity_Pre ?? 'N/A';
		/**
		 * @type {string}
		 */
		this.dayInLifeActivityPost =
			objJobCategoryDetails.DayInLifeActivity_Post ?? 'N/A';
		/**
		 * @type {TrainingTrack[]}
		 */
		this.trainingTracks = objJobCategoryDetails.TrainingTracks ?? [];
		/**
		 * @type {string}
		 */
		this.note = objJobCategoryDetails.Note ?? '';
		/**
		 * @type {boolean}
		 */
		this.active =
			objJobCategoryDetails.Active !== null
				? objJobCategoryDetails.Active
				: true;
	}
}

/**
 * @class
 * @constructor
 * @public
 */
export class DirectReport {
	constructor(objDirectReport) {
		/**
		 * @type {number} unique identifier of direct report
		 */
		this.id = objDirectReport?.ID ?? -1;
		/**
		 * @type {string} full name of direct report
		 */
		this.name = objDirectReport.Name ?? '';
		/**
		 * @type {JobCategoryAssignment} job category assigned to direct report
		 */
		this.assignment = new JobCategoryAssignment(
			objDirectReport.Assignment ?? {},
		);
	}
}

/**
 * @class
 * @constructor
 * @public
 */
export class DirectReportDetails {
	constructor(objDirectReportDetails) {
		/**
		 * @type {string} direct report department assignment.
		 */
		this.department = objDirectReportDetails?.Department ?? '';
		/**
		 * @type {string} direct report job title assignment.
		 */
		this.jobTitle = objDirectReportDetails?.JobTitle ?? '';
	}
}
//#endregion

//#region HTTP payloads
export class PayloadValidate {
	constructor(objPayloadValidate) {
		/**
		 * @type {number} unique identifier of user performing validation.
		 */
		this.UserID = objPayloadValidate?.userID ?? -1;
		/**
		 * @type {DirectReport} updated direct report validation object.
		 */
		this.DirectReport =
			objPayloadValidate?.directReport ?? new DirectReport({});
	}
}

export class PayloadSupplement {
	constructor(arrSupplements) {
		/**
		 * @type {string=} optional value of NPI supplement.
		 */
		this.NPI =
			arrSupplements?.find(
				supplement => supplement.type === OBJ_SUPPLEMENTS.NPI,
			)?.value ?? '';
		/**
		 * @type {{ ResearchTrainingCompleted: Date, ResearchType: string, ResearchID: string }=} optional value of Research supplement.
		 */
		this.Research =
			arrSupplements?.find(
				supplement => supplement.type === OBJ_SUPPLEMENTS.RESEARCH,
			)?.value ?? null;
	}
}

export class PayloadSubmit {
	constructor(objValidate, idSystem = OBJ_APP_BRIDGES.ID, objSupplements = null) {
		/**
		 * @type {PayloadValidate[]} collection of validated assignments.
		 */
		this.Payload = objValidate;
		/**
		 * @type {number} unique identifier of system for which validation is being submitted.
		 */
		this.SystemID = idSystem;
		/**
		 * @type {PayloadSupplement=} optional supplements for validated assignments.
		 */
		this.Supplements = objSupplements;
	}
}
export class ProxyResult {
	constructor(objProxyResult) {
		/**
		 * @type {number} unique identifier of user possessing communication proxy.
		 */
		this.exceptionID = objProxyResult?.ExceptionID ?? -1;
		/**
		 * @type {number} unique identifier of user serving as communication proxy.
		 */
		this.proxyID = objProxyResult?.ProxyID ?? -1;
	}
}
//#endregion
